import { Component } from '@angular/core';
import { EnterpriseOptionType } from '@app/core/interfaces/enterprise-option-type';
import { SecurityPermissionName } from '@app/core/models/permission';
import { SubNavBaseComponent } from '@app/menu/components/sub-nav-base-component';

@Component({
  selector: 'portal-enterprise-settings-sub-nav',
  templateUrl: './enterprise-settings-sub-nav.component.html',
  standalone: false,
})
export class EnterpriseSettingsSubNavComponent extends SubNavBaseComponent {
  EnterpriseOption = EnterpriseOptionType;
  Permission = SecurityPermissionName;
}
